import MyImage from 'components/MyImage';
import Spacing from 'components/Spacing';
import { Box, Stack, VStack } from 'components/Stack';
import Text from 'components/Text';
import { useResponsive } from 'hooks/useResponsive';
import { useTheme } from 'styled-components';

import EyeImg from 'assets/images/eyes.webp';
import StudyDeskImg from 'assets/images/study-desk.webp';
import TagImg from 'assets/images/tag.webp';
import { useTranslation } from 'react-i18next';

const SectionC = ({ onClickBook }: { onClickBook?: () => void }) => {
  const theme = useTheme();
  const { isSmallScreen, isTabletScreen } = useResponsive();
  const { t } = useTranslation();

  return (
    <section className='sectionB'>
      <VStack className='container' $padding='0 1rem'>
        <Text
          color={theme.color.focus200}
          fontSize='1rem'
          fontWeight={700}
        >
          {t('뭐가좋은가요')}
        </Text>
        <Box $width='100%' $alignItems='center'>
          <Text
            $lineHeight='2'
            fontWeight={600}
            as='h2'
            color={theme.color.secondary1000}
            fontSize={isSmallScreen ? '1.6rem' : '2.2rem'}
          >
            {t('카공24의장점')}
          </Text>
        </Box>
        <Spacing />

        <Stack
          $width='100%'
          $alignItems='center'
          $gap='0.5rem'
          $flexDirection={isTabletScreen ? 'row' : 'column'}
        >
          <Box
            $width='100%'
            $height='330px'
            $alignItems='center'
            $justifyContent='center'
            $border={`1px solid ${theme.color.grey300}`}
            $padding='1rem 0.5rem'
            $borderRadius='6px'
            $bgColor={`linear-gradient(0deg, ${theme.color.focus100} 0%,  ${theme.color.grey700} 80%)`}
          >
            <MyImage src={StudyDeskImg} alt='study desk' width={100} height={100} />
            <Spacing margin='0.5rem' />
            <VStack>
              <Text
                fontSize='1.4rem'
                color={theme.color.grey100}
                fontWeight={700}
              >
                {t('카페공부24시간')}
              </Text>
              <Spacing margin='0.2rem' />
              <Text color={theme.color.grey100} fontSize='1rem'>
                {t('밤에도카페공부')}
              </Text>
            </VStack>
          </Box>

          <Box
            $width='100%'
            $height='330px'
            $alignItems='center'
            $justifyContent='center'
            $border={`1px solid ${theme.color.grey300}`}
            $padding='1rem 0.5rem'
            $borderRadius='6px'
            $bgColor={`linear-gradient(180deg, ${theme.color.focus100} 0%,  ${theme.color.secondary800} 70%)`}
          >
            <MyImage src={TagImg} alt='study desk' width={100} height={100} />
            <Spacing margin='0.5rem' />
            <VStack>
              <Text
                fontSize='1.4rem'
                color={theme.color.grey100}
                fontWeight={700}
              >
                {t('저렴한비용')}
              </Text>
              <Spacing margin='0.2rem' />
              <Text color={theme.color.grey100} fontSize='1rem'>
                {t('스터디카페가격비교')}
              </Text>
            </VStack>
          </Box>

          <Box
            $width='100%'
            $height='330px'
            $alignItems='center'
            $justifyContent='center'
            $border={`1px solid ${theme.color.grey300}`}
            $padding='1rem 0.5rem'
            $borderRadius='6px'
            $bgColor={`linear-gradient(180deg, ${theme.color.secondary700} 0%,  ${theme.color.secondary1000} 100%)`}
          >
            <MyImage src={EyeImg} alt='eye' width={100} height={100} />
            <Spacing margin='0.5rem' />
            <VStack>
              <Text
                fontSize='1.4rem'
                color={theme.color.grey100}
                fontWeight={700}
              >
                {t('눈치안보고카공')}
              </Text>
              <Spacing margin='0.2rem' />
              <Text color={theme.color.grey100} fontSize='1rem'>
                {t('눈차안보고카공하세요')}
              </Text>
            </VStack>
          </Box>
        </Stack>
      </VStack>
    </section>
  );
};

export default SectionC;
